import { Box, Button, Center, Divider, Flex, Icon, Text } from '@chakra-ui/react'
import { CircleDownArrow } from '../icons/icons'

const TransactionActivity = ({
  thumbnail,
  title,
  date,
  amount,
  isDeducted,
  file,
}: {
  thumbnail: string
  title: string
  date: Date
  amount: number
  isDeducted?: boolean
  file?: string
}) => {
  return (
    <>
      <Flex gap="20px" alignItems="center" p="15px 0" justify={'space-between'}>
        <Center gap="20px">
          <Box
            w="80px"
            h="68px"
            minW="80px"
            bgImage={thumbnail}
            bgRepeat="no-repeat"
            bgPos="center"
            bgSize="cover"
            borderRadius="10px"
          />
          <Box>
            <Text variant="title" fontSize="lg">
              {title}
            </Text>
            <Flex alignItems="center" gap="5px" flexWrap="wrap">
              <Text variant="title" fontSize="sm" color="#7E8B9A" lineHeight="16px">
                <span style={{ color: '#171C22' }}>Date:</span>{' '}
                {date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}
              </Text>
              <Box bg="#7E8B9A" w="3px" h="3px" borderRadius="50%" />
              <Text variant="title" fontSize="sm" color="#7E8B9A" lineHeight="16px">
                <span style={{ color: '#171C22' }}>Amount:</span> ${amount}{' '}
                {isDeducted ? '(Deducted from your class pack)' : ''}
              </Text>
            </Flex>
          </Box>
        </Center>
        <Box>
          {file && (
            <Button h="35px" borderRadius="170px" onClick={() => window.open(file, '_blank')}>
              <Icon w="20px" h="20px" viewBox="0 0 20 20">
                <CircleDownArrow />
              </Icon>
              <Center ml="8px">
                <Text>Download Report</Text>
              </Center>
            </Button>
          )}
        </Box>
      </Flex>
      <Divider />
    </>
  )
}

export default TransactionActivity